import { ReporteMedidores } from './../../../_entities/medidores/ReporteMedidores';
import { MedidorModal } from './../../../_entities/medidores/MedidorModal';
import { environment } from './../../../../environments/environment';
import { Medidores } from './../../../_entities/medidores/Medidores';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MedidorUltimaTransmision } from './../../../_entities/medidores/medidorUltimaTransmision';

@Injectable({
  providedIn: 'root'
})
export class MedidoresService {

  constructor(private http: HttpClient) { }

  obtenerMedidores(): Observable<Medidores[]> {
    return this.http.get<Medidores[]>(environment.API_SECURITY + '/api/Medidores');
  }

  getMedidores() {
    return this.http.get<Medidores[]>(environment.API_SECURITY + '/api/Medidores');
  }

  obtenerMedidor(imei): Observable<MedidorModal> {
    return this.http.get<MedidorModal>(environment.API_SECURITY + '/api/Medidores/medidorModal/' + imei);
  }

  obtenerReportePosicionesMedidores(medidorImei, fechaInicio, fechaFinal): Observable<ReporteMedidores[]> {
    return this.http.get<ReporteMedidores[]>(`${environment.API_SECURITY}/api/Medidores/${medidorImei}/reporte-historico?fechaInicio=${fechaInicio}&fechaFinal=${fechaFinal}`);
  }

  obtenerUltimoMedidor(): Observable<MedidorUltimaTransmision[]> {
    return this.http.get<MedidorUltimaTransmision[]>(environment.API_SECURITY + '/api/Medidores/ultimamedidor');
  }
}
